import * as React from 'react'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import ProTip from './ProTip'
import { HashRouter, Route, Routes } from 'react-router-dom'
import ChatUI from './Chat'
import { Auth } from 'aws-amplify'
import { configureAmplify } from './aws'
import { Authenticator } from '@aws-amplify/ui-react'
import { type AmplifyUser } from '@aws-amplify/ui'
import { type SignOut } from '@aws-amplify/ui-react/dist/types/components/Authenticator/Authenticator'
import ListConversations from './ListConversations'
import Settings from './Settings'
import TranslationSettings from './TranslationSettings'
import ChatUIVoiceOnly from './ChatVoiceOnly'
import HowDoYouSay from './HowDoYouSay'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'

configureAmplify()

function Copyright (): JSX.Element {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}.
    </Typography>
  )
}

class Home extends React.Component {
  render (): JSX.Element {
    return (
      <Container maxWidth="xl">

        <Box sx={{ my: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Header
          </Typography>
          <ul>
          <li><a href='/#/chat'>Chat</a></li>
          {/* <li><a href='/#/chat-vo'>Chat (voice only)</a></li> */}
          <li><Link href='/#/list'>List Conversations</Link></li>
          <li><Link href='/#/settings'>Settings</Link></li>
          <li><Link href='/#/translation-settings'>Translation Settings</Link></li>
          <li><Link href='/#/how-do-you-say?lang=es-MX'>How do you say? (mexican spanish)</Link></li>
          </ul>
          <ProTip />
          <Copyright />
        </Box>
      </Container>
    )
  }
}

class Chat extends React.Component {
  render (): JSX.Element {
    return (
      <Container maxWidth="lg">

        <Box sx={{ my: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            ULA chat
          </Typography>
          <ChatUI></ChatUI>
          <ProTip />
          <Copyright />
        </Box>
      </Container>
    )
  }
}

class ChatVoiceOnly extends React.Component {
  render (): JSX.Element {
    return (
      <Container maxWidth="lg">

        <Box sx={{ my: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            ULA chat
          </Typography>
          <ChatUIVoiceOnly></ChatUIVoiceOnly>
          <ProTip />
          <Copyright />
        </Box>
      </Container>
    )
  }
}

export default function App (): JSX.Element {
  return (
    <Authenticator>
    {({ signOut, user }) => <PostLogin user={user} signOut={signOut} />}

      {/* <BrowserRouter basename='/'>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/read" element={<Read />} />
        </Routes>
      </BrowserRouter> */}
    </Authenticator>
  )
}

interface PostLoginProps {
  user?: AmplifyUser
  signOut?: SignOut
}

const darkTheme = createTheme({
  palette: {
    mode: 'light',
  },
});

function PostLogin (props: PostLoginProps): JSX.Element {
  const [loaded, setLoaded] = React.useState(false)
  React.useEffect(() => {
    void Auth.currentSession().then((currentSession) => {
      localStorage.setItem('cognito', currentSession.getIdToken().getJwtToken())
      setLoaded(true)
    })
  }, [])
  if (!loaded) {
    return (<div>Loading authenticator...</div>)
  }
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <div>
        <p>Welcome {(props.user != null) ? props.user.username : ''}</p>
              <button onClick={props.signOut}>Sign out</button>
    <HashRouter basename='/'>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/chat-vo" element={<ChatVoiceOnly />} />
            <Route path="/list" element={<ListConversations />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/translation-settings" element={<TranslationSettings />} />
            <Route path="/how-do-you-say" element={<HowDoYouSay />} />
          </Routes>
      </HashRouter>
      </div>
    </ThemeProvider>
  )
}
